import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { motion } from "framer-motion";

export default function MentionsLegales() {
  return (
    <div className="min-h-screen" data-testid="mentions-legales-page">
      <Header />
      <main>
        {/* Hero */}
        <section className="bg-gradient-to-br from-sky-500 to-blue-700 py-16 sm:py-20">
          <div className="max-w-7xl mx-auto px-6 sm:px-8 text-center">
            <motion.h1 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="font-['Outfit'] text-3xl sm:text-4xl font-bold text-white"
            >
              Mentions Légales
            </motion.h1>
          </div>
        </section>

        {/* Content */}
        <section className="py-16">
          <div className="max-w-4xl mx-auto px-6 sm:px-8">
            <div className="prose prose-slate max-w-none space-y-8">
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  1. Éditeur du site
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Le présent site est édité par la société <strong>E@TECH</strong>, SAS au capital social de 15 000 €, immatriculée au Registre du Commerce et des Sociétés (RCS) de Nancy sous le numéro <strong>751222324</strong>.<br /><br />
                  <strong>Siège social :</strong> 11 rue d'Amsterdam, 54500 VANDOEUVRE-LES-NANCY<br />
                  <strong>Numéro de TVA intracommunautaire :</strong> FR24751222324<br />
                  <strong>Téléphone :</strong> +33 3 55 20 50 51<br />
                  <strong>Email :</strong> contact@eatech.fr
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  2. Directeur de la publication
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Le directeur de la publication est <strong>SROUJI ALBERT</strong>, en sa qualité de Président.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  3. Hébergement
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Ce site est hébergé par la société <strong>Emergent</strong>, dont le siège social est situé au :<br />
                  548 Market St, PMB 20548, San Francisco, CA 94104, États-Unis.<br />
                  Email : support@emergent.sh
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  4. Propriété intellectuelle
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle.
                </p>
                <p className="text-slate-700 leading-relaxed mt-4">
                  Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
                </p>
                <p className="text-slate-700 leading-relaxed mt-4">
                  La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite sauf autorisation expresse du directeur de la publication.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  5. Protection des données personnelles (RGPD)
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi « Informatique et Libertés », la société <strong>E@TECH SAS</strong> s'engage à préserver la confidentialité des informations fournies en ligne par l'internaute.
                </p>
                <p className="text-slate-700 leading-relaxed mt-4">
                  <strong>Finalité du traitement :</strong> Les données collectées via les formulaires de contact sont destinées exclusivement à la gestion de vos demandes et à la relation commerciale.
                </p>
                <p className="text-slate-700 leading-relaxed mt-4">
                  <strong>Droit d'accès et de rectification :</strong> Vous disposez d'un droit d'accès, de rectification, d'opposition et de suppression des données vous concernant. Vous pouvez exercer ce droit à tout moment en envoyant un email à : <a href="mailto:contact@eatech.fr" className="text-sky-600 hover:text-sky-700">contact@eatech.fr</a>.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  6. Gestion des cookies
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Le site peut avoir recours à des techniques de « cookies » lui permettant de traiter des statistiques et des informations sur le trafic.
                </p>
                <p className="text-slate-700 leading-relaxed mt-4">
                  Vous pouvez vous opposer à l'enregistrement de ces cookies en configurant votre logiciel de navigation.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.7 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  7. Limitation de responsabilité
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Les informations contenues sur ce site sont aussi précises que possible et le site est périodiquement remis à jour, mais peut toutefois contenir des inexactitudes ou des omissions.
                </p>
                <p className="text-slate-700 leading-relaxed mt-4">
                  E@TECH SAS ne pourra être tenue responsable des dommages directs et indirects causés au matériel de l'utilisateur lors de l'accès au site, résultant de l'utilisation d'un matériel ne répondant pas aux spécifications techniques requises ou de l'apparition d'un bug.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.8 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  8. Liens hypertextes
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Le site peut contenir des liens hypertextes vers d'autres sites.
                </p>
                <p className="text-slate-700 leading-relaxed mt-4">
                  E@TECH SAS n'exerce aucun contrôle sur le contenu de ces sites tiers et décline toute responsabilité quant aux dommages résultant de leur consultation.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.9 }}
              >
                <h2 className="font-['Outfit'] text-2xl font-bold text-blue-900 mb-4">
                  9. Droit applicable
                </h2>
                <p className="text-slate-700 leading-relaxed">
                  Tout litige en relation avec l'utilisation du site est soumis au droit français.
                </p>
                <p className="text-slate-700 leading-relaxed mt-4">
                  Il est fait attribution exclusive de juridiction aux tribunaux compétents de Nancy.
                </p>
              </motion.div>

            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
